__turbopack_context__.v({
  "bestPractices": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__bestPractices",
  "bestPracticesTitle": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__bestPracticesTitle",
  "checkbox": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__checkbox",
  "checkboxLabel": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__checkboxLabel",
  "checkboxText": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__checkboxText",
  "checkboxWrapper": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__checkboxWrapper",
  "closeButton": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__closeButton",
  "content": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__content",
  "continueButton": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__continueButton",
  "description": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__description",
  "dialog": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__dialog",
  "iconWrapper": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__iconWrapper",
  "overlay": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__overlay",
  "practiceContent": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__practiceContent",
  "practiceIcon": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__practiceIcon",
  "practiceItem": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__practiceItem",
  "practiceText": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__practiceText",
  "practiceTitle": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__practiceTitle",
  "subTitle": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__subTitle",
  "title": "InvalidOfficeHoursLinkDialog-module-scss-module__U2CuGa__title",
});
